import { MultiplyPlaceOrderWrapperItem } from './MultiplyPlaceOrderWrapperItem';
export class MultiplyPlaceOrderWrapper {
    constructor() {
        this.orderEditsArr = [];
        this.mapByAccount = new Map();
        this.placedFrom = null;
    }
    AddItem(orderId, orderEditBase) {
        const curArray = this.GetArrayByAccount(orderEditBase.account);
        this.placedFrom = orderEditBase.placedFrom;
        const newItem = new MultiplyPlaceOrderWrapperItem(orderId, orderEditBase);
        curArray.push(newItem);
        this.orderEditsArr.push(newItem);
    }
    GetArrayByAccount(account) {
        if (!this.mapByAccount.has(account)) {
            this.mapByAccount.set(account, []);
        }
        return this.mapByAccount.get(account);
    }
    GetAllOrderEditsArr() {
        const res = [];
        for (const item of this.orderEditsArr) {
            res.push(item.orderEditBase);
        }
        return res;
    }
    GetAllAccounts() {
        return [...this.mapByAccount.keys()];
    }
    GetAllOrdersId() {
        const res = [];
        this.mapByAccount.forEach((items) => {
            for (const item of items) {
                res.push(item.orderId);
            }
        });
        return res;
    }
}
